module.exports = __webpack_public_path__ + "../public/img/heat.7334ba56.png";